module.exports = __webpack_public_path__ + "static/media/purpleLogo.2fb04af5.png";